
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg","data-token-name":"link-block"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.133 6.877v-5a1.25 1.25 0 00-1.25-1.25h-15a1.25 1.25 0 00-1.25 1.25v13.75a1.25 1.25 0 001.25 1.25h5m-6.25-12.5h17.5m-3.746 11.774a1.9 1.9 0 01-.532 1.6l-1.077 1.077a2.013 2.013 0 01-2.846-2.845l1.077-1.077a1.897 1.897 0 011.565-.537m3.583.011a1.902 1.902 0 001.6-.532l1.076-1.077a2.013 2.013 0 00-2.845-2.845l-1.071 1.077a1.893 1.893 0 00-.537 1.565m-1.872 3.684l3.75-3.75","stroke":"currentColor","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    